// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sort-toggle[data-v-92e7f910]{border-radius:50%;flex-shrink:0;font-size:17px;height:48px;padding:8px;width:48px}.dd-carret[data-v-92e7f910]{font-size:18px;transform:rotate(0deg);transition:transform .15s ease}.active .dd-carret[data-v-92e7f910]{transform:rotate(180deg)}.moder-placeholder[data-v-92e7f910]{background-color:var(--color-cases-purple-dim);border-radius:8px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
